{
  "flash": {
    "projection_pending": "Your shortlist was saved, but its search results are still catching up. Refresh in a moment to see them."
  },
  "membership": {
    "title": "In your shortlists",
    "just_added": "Just added",
    "view_shortlist": "View shortlist {{name}}"
  },
  "index": {
    "title": "Shortlists",
    "create": "Create Shortlist",
    "empty": "No shortlists. Click the add button to create your first shortlist.",
    "empty_list_title": "No Shortlists",
    "empty_list_description": "Click the create button to create your first shortlist.",
    "empty_list_unavailable_description": "There are no shortlists for you to view.",
    "view": "View Shortlist",
    "view_classes": "View Saved Classes",
    "view_educators": "View Saved Educators",
    "class_count_one": "{{count}} class",
    "class_count_other": "{{count}} classes",
    "educator_count_one": "{{count}} educator",
    "educator_count_other": "{{count}} educators"
  },
  "form": {
    "name.label": "Name",
    "name.placeholder": "Enter a name for your shortlist",
    "curriculum.label": "Curriculum",
    "curriculum.placeholder": "Please select a curriculum for your shortlist",
    "subject.label": "Subject",
    "subject.placeholder": "Please select a subject for your shortlist"
  },
  "new": {
    "title": "Create New Shortlist"
  },
  "workspace": {
    "title": "Shortlist",
    "rename": "Rename",
    "rename_dialog": {
      "title": "Rename Shortlist"
    },
    "tabs": {
      "classes": "Classes ({{count}})",
      "educators": "Educators ({{count}})"
    },
    "classes": {
      "view_class": "View Class"
    },
    "educators": {
      "view_educator": "View Educator"
    }
  },
  "shortlistable_item_form": {
    "shortlist_type": "Shortlist Type",
    "name.label": "Name",
    "select_shortlist": "Select a Shortlist",
    "saved": "Already saved"
  },
  "saved_classes": {
    "title": "Save Class to Shortlist",
    "form": {
      "new_label": "New Shortlist",
      "new_description": "Create a new shortlist to save this class to.",
      "existing_label": "Existing Shortlist",
      "existing_description": "Select an existing shortlist to save this class to."
    },
    "class_sources": {
      "all-classes": "All Shortlisted Classes",
      "direct": "Directly Shortlisted Classes"
    }
  },
  "saved_educators": {
    "title": "Save Educator to Shortlist",
    "form": {
      "new_label": "New Shortlist",
      "new_description": "Create a new shortlist to save this educator to.",
      "existing_label": "Existing Shortlist",
      "existing_description": "Select an existing shortlist to save this educator to."
    }
  }
}
